import { createRootRoute, HeadContent, Outlet, redirect, useLocation } from '@tanstack/react-router';
import DashboardLayout from 'components/Dashboard';
import { PublicLayout } from 'components/PublicLayout';
import { getToken } from 'engine/api';
import { appConfig } from 'engine/appConfig';
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

const RouteComponent = () => {
	const loc = useLocation();

	switch (loc.pathname) {
		case '/login':
		case '/login-result':
		case '/forgot-password':
			return (
				<>
					<HeadContent />

					<PublicLayout>
						<Outlet />
					</PublicLayout>
				</>
			);
		case '/reset-password':
		case '/confirm-registration':
			return (
				<>
					<HeadContent />
					<Outlet />
				</>
			);
		default:
			return (
				<>
					<HeadContent />

					<DashboardLayout>
						<Outlet />
					</DashboardLayout>
				</>
			);
	}
};

export const Route = createRootRoute({
	component: RouteComponent,
	errorComponent: ({ error }) => {
		console.error(error);
		return <div>Error: {error.message}</div>;
	},
	beforeLoad: ({ location }) => {
		const publicRoutes = ['/login', '/forgot-password', '/login-result'];
		const token = getToken();

		const isPublicRoute = publicRoutes.includes(location.pathname);

		if ((token && location.pathname == '/login') || location.pathname == '/') {
			throw redirect({ to: '/dashboard' });
		}

		if (!token && !isPublicRoute) {
			throw redirect({ to: '/login' });
		}
	},

	head: () => ({
		meta: [
			{
				title: `${appConfig.title} Console${import.meta.env.DEV ? ' dev' : ''}`,
			},
		],
		// links: [
		// 	{
		// 		rel: 'icon',
		// 		href: '/favicon.ico',
		// 	},
		// ],
	}),
});
